"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertToArray = void 0;
const class_transformer_1 = require("class-transformer");
const ConvertToArray = () => (0, class_transformer_1.Transform)(({ value }) => {
    if (!value)
        return undefined;
    return value instanceof Array ? value : [value];
});
exports.ConvertToArray = ConvertToArray;
